<template>
    <div class="conversation-thread">
        <div
            v-for="message in messages"
            :key="message.id"
            class="conversation-thread__message"
            :class="{ 'conversation-thread__message--received': isReceived(message) }"
        >
            <div class="conversation-thread__sender">
                {{ message.sender.title }}
            </div>
            <div class="conversation-thread__bubble">
                {{ message.message }}
            </div>
            <small class="conversation-thread__time text-muted">
                {{ renderDateTime(message.sentAt) }}
            </small>
        </div>
    </div>
</template>

<script>
import dateRenderer from '@core/mixins/date-renderer'

export default {
    name: 'ConversationThreadV2',
    mixins: [dateRenderer],
    props: {
        subscriberId: {
            type: [String, Number],
            default: null,
        },
        messages: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        isReceived(message) {
            return message.sender && String(message.sender.id) === String(this.subscriberId)
        },
    },
}
</script>

<style scoped lang="scss">
.conversation-thread__message {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-bottom: 0.75rem;
}

.conversation-thread__message--received {
    align-items: flex-start;
}

.conversation-thread__sender,
.conversation-thread__time {
    font-size: 0.75rem;
}

.conversation-thread__sender {
    margin-bottom: 0.2rem;
    font-weight: 600;
}

.conversation-thread__bubble {
    max-width: 88%;
    padding: 0.625rem 0.75rem;
    border-radius: 0.5rem;
    background: #f3f2f7;
    white-space: pre-wrap;
}

.conversation-thread__message--received .conversation-thread__bubble {
    background: #e7f4ff;
}

.conversation-thread__time {
    margin-top: 0.2rem;
}
</style>
